import { css } from 'emotion';

export const link = css`
  color: white;
  text-decoration: none;
`;
